import React from "react";
import transporterLogo from "../assets/TheTransporter.png";

export default function HomePage() {
  return (
    <main className="bg-gray-950 min-h-screen font-sans text-white">

      <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-6 pt-24 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-yellow-400/10 rounded-full blur-3xl" />
        </div>
        <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-8">
          <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full inline-block" />
          Serving Mississippi Communities
        </div>
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-tight mb-6 max-w-4xl">
          Ride in <span className="text-yellow-400">Comfort.</span>
          <br />
          Arrive in <span className="text-yellow-400">Style.</span>
        </h1>
        <p className="text-gray-400 text-lg md:text-xl max-w-2xl mb-10 leading-relaxed">
          Whether you are commuting to work, attending an event, or traveling in luxury, The Transporter has a service that fits your needs.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <a href="mailto:tmac@themacbus.com" className="bg-yellow-400 text-gray-950 font-bold px-8 py-4 rounded-full shadow-lg shadow-yellow-400/20 hover:bg-yellow-300 transition hover:-translate-y-1 transform">Book Your Ride</a>
          <a href="#services" className="text-gray-400 text-sm font-medium hover:text-white transition flex items-center gap-2">See our services</a>
        </div>
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-600 text-xs animate-bounce">
          <span>Scroll down</span>
        </div>
      </section>

      <section className="border-y border-white/5 bg-white/5">
        <div className="max-w-6xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { num: "100+", label: "Happy Riders" },
            { num: "3", label: "Service Types" },
            { num: "24/7", label: "Availability" },
            { num: "MS", label: "Statewide Coverage" },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-3xl font-extrabold text-yellow-400">{stat.num}</div>
              <div className="text-xs text-gray-500 uppercase tracking-widest mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section id="services" className="max-w-6xl mx-auto px-6 py-24">
        <div className="text-center mb-14">
          <div className="text-yellow-400 text-xs font-bold tracking-widest uppercase mb-3">What We Offer</div>
          <h2 className="text-4xl font-extrabold tracking-tight">Services built for every rider.</h2>
          <p className="text-gray-400 mt-3 max-w-xl mx-auto">From daily commutes to special occasions, we have a transportation solution for you.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: "🚌", title: "Fixed Route Shuttles", desc: "Convenient scheduled routes to get you where you need to go affordably and on time." },
            { icon: "✨", title: "Luxury Transportation", desc: "Travel in style with premium vehicles for special occasions and group bookings." },
            { icon: "🤝", title: "Community Driven", desc: "We focus on equity and access, working with local partners to serve Mississippi communities." },
          ].map((service) => (
            <div key={service.title} className="group bg-white/5 border border-white/10 rounded-2xl p-8 hover:border-yellow-400/50 hover:bg-yellow-400/5 transition-all duration-300">
              <div className="text-4xl mb-5">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{service.desc}</p>
              <div className="mt-6 text-yellow-400 text-sm font-semibold opacity-0 group-hover:opacity-100 transition">Learn more</div>
            </div>
          ))}
        </div>
      </section>

      <section id="about" className="max-w-6xl mx-auto px-6 pb-24">
        <div className="relative bg-yellow-400 rounded-3xl px-10 py-16 text-center overflow-hidden">
          <div className="absolute inset-0 pointer-events-none opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gray-900 rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gray-900 rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>
          <div className="relative z-10">
            <h2 className="text-gray-950 text-4xl font-extrabold tracking-tight mb-4">Ready to ride with us?</h2>
            <p className="text-gray-800 max-w-lg mx-auto mb-8 text-lg">Have a special request, group booking, or want more details? Contact us today and lets get you moving.</p>
            <a href="mailto:tmac@themacbus.com" className="inline-block bg-gray-950 text-yellow-400 font-bold px-10 py-4 rounded-full shadow-xl hover:bg-gray-800 transition hover:-translate-y-1 transform">Contact Us Today</a>
          </div>
        </div>
      </section>

      <footer className="border-t border-white/10 py-8 text-sm text-gray-600">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <img src={transporterLogo} alt="The Transporter" className="h-8 w-auto opacity-60" />
          <span>Copyright {new Date().getFullYear()} The Transporter. All rights reserved.</span>
          <div className="flex flex-col items-center md:items-end gap-1">
            <a href="mailto:tmac@themacbus.com" className="text-yellow-400 hover:text-yellow-300 transition">tmac@themacbus.com</a>
            <p className="text-gray-700 text-xs">Site designed and built by <a href="https://ivleaguebusiness.com" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 transition">ivLeague Business</a></p>
          </div>
        </div>
      </footer>

    </main>
  );
}
